import { useRouteLoaderData } from "@remix-run/react";

import { sanitizeVerification } from "~/lib/tracking/config";

import type { ParentRouteData } from "~/modules/layout";

/**
 * `<meta>` de verificación de dominio (Google Search Console, Meta Business, Bing Webmaster).
 * Los valores se cargan en /admin/tracking — nunca en el código — y sin valor no se emite nada.
 * Salen en el HTML del SSR porque cada consola verifica leyendo el documento sin ejecutar JS.
 */
export function SiteVerificationMeta() {
  const data = useRouteLoaderData<ParentRouteData>("modules/layout");
  const verification = sanitizeVerification(data?.tracking?.verification);

  return (
    <>
      {verification.google && (
        <meta name="google-site-verification" content={verification.google} />
      )}
      {verification.meta && (
        <meta name="facebook-domain-verification" content={verification.meta} />
      )}
      {verification.bing && <meta name="msvalidate.01" content={verification.bing} />}
    </>
  );
}
